import "./Loading.css";
import logoBig from "../../../assets/custom/classic/logo_splash_big.png";
import packageInfo from '../../../../package.json';
import logoSmall from "../../../assets/custom/classic/logo_splash_small.png";


const Loading = ({ show , isMobile }) => {
  let logo = isMobile ? logoSmall : logoBig;
  return (
  <div id="loading" style={{
    display: show ? 'flex' : 'none', 
    justifyContent: 'center', 
    alignItems: 'center', 
    height: '100vh' 
  }}>
    <div style={{
      display: 'table-cell',
      verticalAlign: 'middle'
    }}>
      <div style={{
        width: '100%',
        textAlign: 'center',
      }}>
        <img
          src={logo}
          alt="Kantar Ibope Media Logo"
        />
        <div className="spinner" style={{
          position: 'absolute',
          top: 100,
          left: '50%',
          marginLeft: -20
        }}></div>
      </div>
    </div>
    <footer
      style={{
        width: '100%',
        textAlign: 'center',
        position: 'absolute',
        bottom: 10,
        left: 0
      }}
    >
      <p id="appName">
        {packageInfo.name}
      </p>
      <p style={{
        opacity: 0.3,
        color:"#ccc"
      }}>
        {`v${packageInfo.version}`}
      </p>
    </footer>
  </div>
  );
}
export default Loading;
